import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  TOKEN_VERIFY,
  TOKEN_VERIFY_SUCCESS,
  TOKEN_VERIFY_FAIL
} from './../constants/ActionTypes';

export function login(payload) {
  return {
    type: LOGIN,
    payload
  };
}

export function loginSuccess(payload) {
  return {
    type: LOGIN_SUCCESS,
    payload
  };
}

export function loginFail(payload) {
  return {
    type: LOGIN_FAIL,
    payload
  };
}

export function logout() {
  return {
    type: LOGOUT
  };
}

export const tokenVerify = token => {
  return {
    type: TOKEN_VERIFY,
    token
  };
};

export const tokenVerifySuccess = token => {
  return {
    type: TOKEN_VERIFY_SUCCESS,
    token
  };
};

export const tokenVerifyFail = error => {
  return {
    type: TOKEN_VERIFY_FAIL,
    error
  };
};
